module.exports = __webpack_public_path__ + "img/sd.4ed7b37b.svg";